// AuthContext.ts
import type { StorageService } from '@/lib/StorageService';
import { createContext } from 'react';

interface AuthContextType {
  tokenService: StorageService | null;
  login: (username: string, password: string, rememberMe: boolean) => Promise<void>;
  refresh: () => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  isLoading: boolean;
  isAuthInitialized: boolean;
  isAuthChecked: boolean;
  isAdmin: () => Promise<boolean>;
  isRefreshingToken: boolean;
  /** Re-reads role, modules and company from the server after they may have changed. */
  reloadProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
